module.exports = __webpack_public_path__ + "static/media/sort-active.96b541a4.svg";